/**
 * website change of 2019-04-18
 */
class ModifyTime20190418 {
  constructor () {
    this.init()
  }
  
  init () {
    if ($('#languageEntries').length > 0) {
      //  add lang entries box
      this._addLangEntriesBox()
      //  add search box inside nav
      this._addSearchBoxInsideNav()
    }
    
    // pc nav sticky
    // window.setTimeout(() => this._navSticky(), 1000)
  }
  
  /**
   * pc nav sticky
   * @private
   */
  _navSticky () {
    $(window).on('resize', ev => {
      if (window.innerWidth >= 1040) {
        $('.genesis-responsive-menu').stick_in_parent()
      } else {
        $('.genesis-responsive-menu').trigger("sticky_kit:detach")
      }
    }).trigger('resize')
  }
  
  
  /**
   * add search box inside nav
   * @private
   */
  _addSearchBoxInsideNav () {
    //  add search btn
    // window.__translate.search
    let oSearchBoxInsideNav = $('.searchBoxInsideNav')
    oSearchBoxInsideNav.find('.widget_search input[type="submit"]').val(window.__translate.search)
    
    $('.searchBoxInsideNav__button').on('click', ev => {
      oSearchBoxInsideNav.find('.widget_search').show()
      oSearchBoxInsideNav.find('.search-form-input').focus()
    })
    
    
    $(document).on('click', ev => {
      if ($(ev.target).parents('.searchBoxInsideNav').length === 0 && oSearchBoxInsideNav.find('.widget_search').css('display') === 'block') {
        oSearchBoxInsideNav.find('.widget_search').hide()
      }
    })
    
    oSearchBoxInsideNav.show()
  }
  
  /**
   * lang entries box Handle
   * @private
   */
  _addLangEntriesBox () {
    $('.site-container-wrap').append(`<div class="languageEntriesBox">${$('#languageEntries').html()}</div>`)
  }
}

export default ModifyTime20190418
